import styles from './sign-request-status-badge.module.scss';

const STATUS_LABELS: Record<string, string> = {
	PENDING: 'Pendiente',
	SIGNED: 'Firmado',
	CANCELLED: 'Cancelado',
};

const STATUS_CLASS: Record<string, string> = {
	PENDING: 'pending',
	SIGNED: 'signed',
	CANCELLED: 'cancelled',
};

export const SignRequestStatusBadge = ({ status }: { status: string }) => (
	<span
		className={[
			styles.badge,
			styles[STATUS_CLASS[status] ?? ''] ?? '',
		].join(' ')}
	>
		{STATUS_LABELS[status] ?? status}
	</span>
);
